import getStyleQuery from '../../../utils/tools/getStyleQuery';

export function svgIcon() {
    return {
        MuiSvgIcon: {
            styleOverrides: {
                fontSizeLarge: {
                    [getStyleQuery()]: {
                        width: 32,
                        height: 32,
                        fontSize: 'inherit',
                    },
                },
            },
        },
    };
}
